

































































import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator'
import ProductItem from '@/components/ProductItem.vue'
import Paginate from '@/components/Paginate.vue'
import routerProvider from '@/router'
import { RawLocation } from 'vue-router'
import searcherryConfig from '@/services/Searcherry/SearcherryConfig'
import searcherry from '@/services/Searcherry/Searcherry'
import { BrowseCategoryEventData, ExitWithCategoryEventData } from '@/services/Statistic/PostData'

@Component({
  name: 'category-results',
  components: { ProductItem, Paginate }
})
export default class CategoryResults extends Vue {
  @Prop() searchResults: any
  @PropSync('searchPhraseProp', { type: String }) searchPhrase!: string
  @Prop() isShowBreadcrumbs: any

  srchrryTrnCategory = ''
  isAnimationEnabled = searcherryConfig.isAnimationEnabled
  page = 1
  pageSize = searcherryConfig.categoryPageSize
  pagingPageRange = 3
  pagingPageMargin = 3

  // todo resize

  created () {
    this.setPageFromRoute()
    document.addEventListener('keydown', this.keydownListener)
    this.srchrryTrnCategory = this.isAnimationEnabled ? 'srchrry-trn-category' : ''
    this.sendStatistic()
    // if ((window.innerWidth >= 900 && window.innerWidth < 1000) || (window.innerWidth > 550 && window.innerWidth < 768)) {
    //   this.pagingPageMargin = 1
    // } else if ((window.innerWidth >= 768 && window.innerWidth < 900) || (window.innerWidth > 480 && window.innerWidth <= 550)) {
    //   this.pagingPageRange = 3
    //   this.pagingPageMargin = 1
    // } else if (window.innerWidth > 410 && window.innerWidth <= 480) {
    //   this.pagingPageRange = 3
    //   this.pagingPageMargin = 2
    // } else
    if (window.innerWidth <= 1000) {
      this.pagingPageMargin = 1
    }
  }

  destroyed () {
    document.removeEventListener('keydown', this.keydownListener)
  }

  private setPageFromRoute () {
    this.page = this.$route.query.page ? parseInt(this.$route.query.page.toString()) : 1
  }

  keydownListener (e: KeyboardEvent) {
    // только при нажатом контроле
    if (!(e.ctrlKey || e.metaKey)) {
      return
    }
    // если фокус не в поисковом инпуте
    if (e.target instanceof Element && e.target.tagName.toLowerCase() === 'input') {
      return
    }

    switch (e.code) {
      case 'ArrowRight':
        const totalPages = Math.ceil(this.searchResults.category.productsCount / this.pageSize)
        if (this.page < totalPages) {
          this.page++
        }
        break

      case 'ArrowLeft':
        if (this.page > 1) {
          this.page--
        }
    }
  }

  @Watch('$route')
  onRouteChanged () {
    this.setPageFromRoute()
  }

  @Watch('searchResults')
  onSearchResultsChanged () {
    if (this.$route.query.page !== this.page.toString() && this.page > 1) {
      this.page = 1
    }

    this.sendStatistic()
  }

  @Watch('page')
  onPageChanged (val: number) {
    let query = (val > 1) ? { page: val.toString() } : {}

    if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
      let router = routerProvider.getRouter()
      let newLoc: RawLocation = {}
      newLoc.name = this.$route.name !== null ? this.$route.name : ''
      newLoc.params = { categoryId: this.$route.params.categoryId }
      newLoc.query = query
      router.push(newLoc)
    }
  }

  paginateClick (pageNum: number) {
    // клик по пейджингу
    // console.log(pageNum)
    // проверяем позицию блока с элементами от viewport. Если экран ниже, то скролим вверх
    let srchrryWr = document.getElementsByClassName('srchrry')[0]
    let srchrryItems = document.getElementsByClassName('srchrry-category__row')[0]
    let srchrryItemsOffset
    if (srchrryItems instanceof HTMLElement) {
      srchrryItemsOffset = srchrryItems.getBoundingClientRect()
    }
    if (srchrryItemsOffset !== undefined) {
    // console.log(srchrryItemsOffset.top)
      if (srchrryItemsOffset.top < 0) {
        srchrryWr.scrollTop = 0
      }
    }
  }

  sendStatistic (): void {
    if (this.searchResults && this.searchResults.category) {
      let data = new BrowseCategoryEventData()
      data.categoryName = this.searchResults.category.data.name
      data.categoryUrl = this.searchResults.category.data.url
      data.searchPhrase = this.$route.params.searchPhrase
      data.pageNum = this.page
      searcherry.statisticService.browseCategoryEvent(data)
    }
  }

  clickCategory (category: any) {
    let data = new ExitWithCategoryEventData()
    data.categoryName = category.name
    data.categoryUrl = category.url
    data.searchPhrase = this.$route.params.searchPhrase
    searcherry.statisticService.exitWithCategoryEvent(data)
    searcherry.generateEvent('exit-category')
  }
}
